import React, { useEffect, useState } from "react"
import { Box, Typography, Tabs, Tab, IconButton, Paper, TextField, Button, MenuItem, InputAdornment, Select, FormControl } from "@mui/material"
import { ArrowBack, Edit, Delete, Phone, Chat, Email, Search } from "@mui/icons-material"
import { Link, useParams } from "react-router-dom"
import CustomTable from "../../components/table/Table"
import { useDispatch, useSelector } from "react-redux"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { fetchCustomerByid } from "../../redux/Slice/customerSlice"
import { toast } from "sonner"
import { clearMessage } from "../../redux/Slice/message"

const CustomerDetailsPage = () => {
  const [activeTab, setActiveTab] = useState("lead")
  const [searchQuery, setSearchQuery] = useState("")
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [status, setStatus] = useState(false)

  const params = useParams();
  const dispatch = useDispatch();
  const id = params?.id;

  useEffect(() => {
      dispatch(setLoading(true))
  
      if (id) {
        
    dispatch(fetchCustomerByid({c_id:id}));
        }
        dispatch(setLoading(false))
        
    }, [dispatch, id]);

    const { customerDetail } = useSelector((state) => state.customer);
    const message = useSelector((state) => state.message);

    console.log("emp",customerDetail)
  
    useEffect(() => {
      if (message?.message) {
        toast(message.message);
        dispatch(clearMessage());
      }
    }, [message, dispatch]);

  const dummyData = {
    companyName: "Asian paint",
    customerId: "C123456",
    gstNo: "GST12345678",
    CusName: "MonikaE",
    emailId: "monika@asiant.com",
    location: "USA",
    createdOn: "15-12-2024",
    status: "Active",
  }

  const [customerDetails, setCustomerDetails] = useState(dummyData)

  const [selectedOption, setSelectedOption] = useState("name")

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const handleSearch = () => {}

  const handleExport = () => {}

  const handleStatus = () => {
    setStatus(!status)
  }

  const handleEdit = (item) => {}

  const handleView = (item) => {}

  const leadColumns = [
    { id: "leadNo", label: "Lead No", minWidth: 150, align: "start" },
    { id: "contactPerson", label: "Contact Person Name (Company Name)", minWidth: 200, align: "start" },
    { id: "contactInfo", label: "Contact Info   (Email, Phone Number)", minWidth: 250, align: "center" },
    { id: "enquireType", label: "Enquire Type", minWidth: 150, align: "center" },
    { id: "statuss", label: "Status", minWidth: 150, align: "center" },
    { id: "action", label: "Action", minWidth: 150, align: "center", actionType: [{ view: true, edit: true }] },
  ]

  const customerColumns = [
    { id: "customerNo", label: "Customer No", minWidth: 150, align: "start" },
    { id: "contactPerson", label: "Contact Person Name", minWidth: 150, align: "start" },
    { id: "contactInfo", label: "Contact Info", minWidth: 250, align: "center" },
    { id: "status", label: "Status", minWidth: 150, align: "center" },
    { id: "action", label: "Action", minWidth: 150, align: "center", actionType: [{ view: true, edit: true }] },
  ]

  const QuoteColumns = [
    { id: "quoteId", label: "Quote ID", minWidth: 150, align: "start" },
    { id: "quoteTitle", label: "Quote Title", minWidth: 200, align: "start" },
    { id: "clientName", label: "Client Name", minWidth: 200, align: "start" },
    { id: "contactInfo", label: "Contact Info", minWidth: 250, align: "center" },
    { id: "projectName", label: "Project Name", minWidth: 200, align: "start" },
    { id: "totalAmount", label: "Total Amount", minWidth: 150, align: "end" },
    { id: "status", label: "Status", minWidth: 150, align: "center" },
    { id: "dateCreated", label: "Date Created", minWidth: 150, align: "center" },
    { id: "dueDate", label: "Due Date", minWidth: 150, align: "center" },
    { id: "actions", label: "Actions", minWidth: 200, align: "center", actionType: [{ view: true, edit: true}] },
  ];
  

  const productColumns = [
    { id: "sno", label: "S.No", minWidth: 150, align: "start" },
    { id: "image", label: "Product Image", minWidth: 150, align: "start", renderCell: (row) => <img src={row.image} alt={row.name} width="50" height="50" /> },
    { id: "name", label: "Product Name", minWidth: 150, align: "start" },
    { id: "price", label: "Product Price", minWidth: 100, align: "start" },
    { id: "description", label: "Product Description", minWidth: 200, align: "start" },
    { id: "features", label: "Product Features", minWidth: 200, align: "start" },
    { id: "companyName", label: "Company Name", minWidth: 150, align: "start" },
    { id: "status", label: "Status", minWidth: 100, align: "center" },
    { id: "action", label: "Action", minWidth: 150, align: "center", actionType: [{ view: true, edit: true }] },
  ]

  const inspirationColumns = [
    { id: "sno", label: "S.No", minWidth: 150, align: "start" },
    { id: "image", label: "Image", minWidth: 150, align: "start", renderCell: (row) => <img src={row.image} alt={row.name} width="50" height="50" /> },
    { id: "name", label: "Name", minWidth: 150, align: "start" },
    { id: "spaceType", label: "Space Type", minWidth: 150, align: "start" },
    { id: "serviceType", label: "Service Type", minWidth: 150, align: "start" },
    { id: "companyName", label: "Company Name", minWidth: 150, align: "start" },
    { id: "status", label: "Status", minWidth: 100, align: "center" },
    {
      id: "action",
      label: "Action",
      minWidth: 150,
      align: "center",
      actionType: [{ edit: true, view: true }],
    },  ]

  const leadRows = [
    { leadNo: "bp01", contactPerson: "Lokesh,(Company A)", contactInfo: "lokesh@example.com, 123-456-7890", enquireType: "Hot", statuss: "New" },
    { leadNo: "bp02", contactPerson: "Vasanth,(Company B)", contactInfo: "vasanth@example.com, 234-567-8901", enquireType: "Cold", statuss: "Assigned" },
  ]

  const customerRows = [
    { customerNo: "C001", contactPerson: "moni", contactInfo: "moni@example.com, 123-456-7890", status: "Active" },
    { customerNo: "C002", contactPerson: "Yasar", contactInfo: "yasar@example.com, 234-567-8901", status: "Inactive" },
  ]

  const productRows = [
    { sno: 1, image: "/product1.png", name: "Product A", price: "$100", description: "Product A description", features: "Feature 1, Feature 2", companyName: "Company A", status: "Active" },
    { sno: 2, image: "/product2.png", name: "Product B", price: "$150", description: "Product B description", features: "Feature 3, Feature 4", companyName: "Company B", status: "Inactive" },
  ]

  const inspirationRows = [
    { sno: 1, image: "/inspiration1.png", name: "Inspiration 1", spaceType: "Space1", serviceType: "Service1", companyName: "Company A", status: "Active" },
    { sno: 2, image: "/inspiration2.png", name: "Inspiration 2", spaceType: "Space2", serviceType: "Service2", companyName: "Company B", status: "Inactive" },
  ]


  const QuoteRows = [
    {
      quoteId: "Q001",
      quoteTitle: "Foundation Quote",
      clientName: "John",
      contactInfo: "john@example.com,123-456-7890",
      projectName: "Residential Building",
      totalAmount: "$25000",
      status: "active",
      dateCreated: "12-12-24",
      dueDate: "15-12-24",
    },
    {
      quoteId: "Q002",
      quoteTitle: "Roofing Quote",
      clientName: "Jane",
      contactInfo: "jane@example.com ,987-654-3210",
      projectName: "Commercial Complex",
      totalAmount: "$50000",
      status: "Active",
      dateCreated: "2024-12-18",
      dueDate: "2024-12-28",
    },
  ];
  

  return (
    <div className="content">
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Link to="/customers">
          <IconButton>
            <ArrowBack />
          </IconButton>
        </Link>
        <Typography variant="h6" sx={{ marginLeft: 2 }}>
          Customer Details
        </Typography>
      </Box>

      <Paper sx={{ marginTop: 3, padding: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">{customerDetail?.companyName}</Typography>
          <Typography variant="h5">Customer ID: {customerDetail?.customer_id}</Typography>
          <Typography variant="h6">
          <a href={customerDetail?.domain} rel="noreferrer" target="_blank">{customerDetail?.domain}</a></Typography>

          <Box>
            <IconButton>
              <Edit />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Typography variant="body2">
            Customer Type :
            <br /> {customerDetail?.customer_type}
          </Typography>
          <Typography variant="body2">
            Company Email : <br />
            {customerDetail?.company_email}
          </Typography>
          <Typography variant="body2">
            Location :
            <br /> {customerDetail?.location?.city}, {customerDetail?.location?.state}, {customerDetail?.location?.country}
          </Typography>
          <Typography variant="body2">
            Status :
            <br /> {customerDetail?.status ? "Active" : "Inactive"}
          </Typography>
          <Box display="flex" gap={2}>
            {/* <IconButton>
              <Phone color="primary" />
            </IconButton>
            <IconButton>
              <Chat color="primary" />
            </IconButton> */}
            <a href={`mailto:${customerDetail?.company_email}`}>
            <IconButton>
              <Email color="primary" />
            </IconButton>
            </a>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ width: "100%", mt: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
           indicatorColor="transparent" 
           variant="fullWidth"

           textColor="inherit"
        >
          <Tab value="lead" label="Lead Management" />
          <Tab value="customer" label="Customers" />
          <Tab value="products" label="Products" />
          <Tab value="inspiration" label="Inspiration" />
          <Tab value="chat" label="Chat" />
          <Tab value="quote" label="Quotation" />

        </Tabs>

        <Box sx={{ mb: 2, mt: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <FormControl size="small" sx={{ mr: 2 }}>
              <Select value={selectedOption}>
                <MenuItem value="name">By Name</MenuItem>
                <MenuItem value="status">By Status</MenuItem>
              </Select>
            </FormControl>


            <TextField
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                    <Search />

                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>

          <CustomTable columns={activeTab === "lead" ? leadColumns
             : activeTab === "customer" ? customerColumns 
             : activeTab === "products" ? productColumns
             : activeTab === "quote" ? QuoteColumns

              : inspirationColumns} 
              rows={activeTab === "lead" ? leadRows 
              : activeTab === "customer" ? customerRows
               : activeTab === "products" ? productRows 
               : activeTab === "quote" ?  QuoteRows

               : inspirationRows}
                page={page} 
                setPage={setPage}
                 rowsPerPage={rowsPerPage} 
                 setRowsPerPage={setRowsPerPage} 
                 handleEdit={handleEdit} 
                 handleView={handleView} />
        </Box>
      </Box>
    </div>
  )
}

export default CustomerDetailsPage
